import * as finalForm from 'final-form';
import * as finalFormArrays from 'final-form-arrays';
import * as reactFinalForm from 'react-final-form';
import * as reactFinalFormArrays from 'react-final-form-arrays';
import * as validators from '@mihanizm56/validators';
import * as confirmModal from '@wildberries/confirm-modal-portal';
import * as previewComponent from '@wildberries/preview-component';
import * as notifications from '@wildberries/notifications';
import * as reactTransitionGroup from 'react-transition-group';

export const externalPackages: any = {
  'final-form': finalForm,
  'final-form-arrays': finalFormArrays,
  'react-final-form': reactFinalForm,
  'react-final-form-arrays': reactFinalFormArrays,
  '@mihanizm56/validators': validators,
  '@wildberries/confirm-modal-portal': confirmModal,
  'react-transition-group': reactTransitionGroup,
  '@wildberries/notifications': notifications,
  '@wildberries/preview-component': previewComponent,
};
